var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '../..';
export var Badge = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.color, color = _b === void 0 ? 'errorMain' : _b;
    return (_jsx("span", __assign({ className: classNames(className, 'inline-flex items-center justify-center rounded-full px-3 py-1 text-xs font-bold leading-none', "bg-".concat(color)) }, { children: children })));
};
//# sourceMappingURL=badge.js.map